<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        © {{ year }} made with <i class="tim-icons icon-heart-2"/> by
        <a
          href="https://deyikong.github.io"
          target="_blank"
          rel="noopener">Deyi Kong</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style>
</style>
